import { Box, Button, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Select, Stack, Typography } from "@mui/material";
import useGetFile from "hooks/useGetFile";
import { useMemo, useState } from "react";
import { useRecoilValue } from "recoil";
import { HRcompanyInfo } from "recoil/store";
import { bizCode } from "utils/bizCode";
import { companyCodeConvert } from "utils/companyCodeConvert";

const SingleFileDownload = ({ roomTesterInfo, onClose }) => {
  const companyInfo = useRecoilValue(HRcompanyInfo);
  const [downloadReport, setDownloadReport] = useState(false);
  const [reportCategory, setReportCategory] = useState(companyInfo.companyCode === "LGES" ? "CUSTOMIZED" : "PERSONAL");

  const handleChange = (event) => {
    setReportCategory(event.target.value);
  };
  useGetFile(
    "HR",
    "singleFileDownload",
    { testerIdx: Number(roomTesterInfo.testerIdx), companyCode: companyCodeConvert(roomTesterInfo.companyName), reportCategory: reportCategory },
    downloadReport,
    setDownloadReport
  );

  const disabledParam = useMemo(() => {
    if (companyInfo.companyCode === "LGES") {
      return true;
    } else {
      return false;
    }
  }, [companyInfo]);

  const handleSubmit = () => {
    setDownloadReport((prev) => !prev);
  };
  return (
    <>
      <DialogTitle>레포트 개별 다운로드</DialogTitle>
      <DialogContent>
        <Box py={2}>
          <Grid container columnGap={5}>
            <Stack>
              <Typography fontSize={11} color={"gray"}>
                성명
              </Typography>
              <Typography fontSize={11}>{`${roomTesterInfo.testerName}`}</Typography>
            </Stack>
            <Stack>
              <Typography fontSize={11} color={"gray"}>
                연락처
              </Typography>
              <Typography fontSize={11}>{`${roomTesterInfo.testerCell}`}</Typography>
            </Stack>
            <Stack>
              <Typography fontSize={11} color={"gray"}>
                생년월일
              </Typography>
              <Typography fontSize={11}>{`${roomTesterInfo.testerBirth}`}</Typography>
            </Stack>
            <Stack>
              <Typography fontSize={11} color={"gray"}>
                직군
              </Typography>
              <Typography fontSize={11}>{`${bizCode(roomTesterInfo.bizCode)}`}</Typography>
            </Stack>
          </Grid>
          <Stack mt={3}>
            <Typography fontSize={11} color={"gray"}>
              레포트 유형 선택
            </Typography>
            <Select placeholder="레포트 유형을 선택해 주세요." size="small" labelId="selectType" id="selectType" value={reportCategory} onChange={handleChange}>
              <MenuItem disabled={disabledParam} value={"PERSONAL"}>
                개인 레포트
              </MenuItem>
              <MenuItem disabled={disabledParam} value={"INTERVIEW"}>
                면접관 레포트
              </MenuItem>
              {companyInfo.companyCode === "LGES" || companyInfo.companyCode === "ACG" ? <MenuItem value={"CUSTOMIZED"}>특화요인 레포트</MenuItem> : null}
            </Select>
          </Stack>
        </Box>
      </DialogContent>

      <DialogActions sx={{ padding: 2 }}>
        <Button variant={"contained"} onClick={handleSubmit}>
          확인
        </Button>
        <Button variant={"outlined"} onClick={onClose}>
          취소
        </Button>
      </DialogActions>
    </>
  );
};

export default SingleFileDownload;
